import classnames from 'classnames';
import { useState, useEffect } from 'react';
import { fetchRecognitions, Recognition } from '@services/recognitions';
import {
  getRegistrations,
  RegistrationStatus,
  Registration,
} from '@services/registrations';
import { AchievementList } from '@components/shared/atoms/AchievementList/AchievementList';
import { AchievementListItem } from '@components/shared/atoms/AchievementListItem/AchivemenetListItem';

import styles from './AchievementsCard.module.scss';

export function AchievementsCard({ className }: { className?: string }) {
  const [recognitions, setRecognitions] = useState<Recognition[]>([]);
  const [participations, setParticipations] = useState<Registration[]>([]);

  useEffect(() => {
    fetchRecognitions().then(setRecognitions);

    getRegistrations({
      ended: true,
      status: RegistrationStatus.CONFIRMED,
    }).then((data) => {
      setParticipations(data.results);
    });
  }, []);

  if (participations.length === 0 && recognitions.length === 0) {
    return null;
  }

  return (
    <div className={classnames(styles.card, className)}>
      {participations.length > 0 && (
        <AchievementList title="Participaciones como voluntario">
          {participations.map((participation) => (
            <AchievementListItem
              key={participation.id}
              text={participation.event.fullName}
            />
          ))}
        </AchievementList>
      )}
      {recognitions.length > 0 && (
        <AchievementList title="Menciones">
          {recognitions.map((recognition) => (
            <AchievementListItem
              key={recognition.id}
              text={recognition.displayName}
            />
          ))}
        </AchievementList>
      )}
    </div>
  );
}
